import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Projects } from "../Data/Data";
import {
  delayNavigation,
  getApartmentTypeByIds,
  getCoordinatesObjById,
} from "../helpers/helpers";
import { ApartmentsTypes } from "../Data/ApartmentsTypes";
import Section from "../components/Section";
import { TiArrowSortedDown } from "react-icons/ti";
import { useDispatch } from "react-redux";
import ApartmentPath from "../components/ApartmentPath";

const VisualSearchFloor = () => {
  const { floorId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedProject, setSelectedProject] = useState({});
  const [hoveredFlat, setHoveredFlat] = useState(null);

  useEffect(() => {
    setHoveredFlat(null);
  }, [floorId]);

  useEffect(() => {
    const projectName = location.pathname.split("/")[2];
    const projectObj = Projects.find(
      (project) => project.name.toLowerCase() === projectName.toLowerCase()
    );
    setSelectedProject(projectObj);
  }, [location.pathname, floorId]);

  const apartmentsList = useMemo(() => {
    const floor = selectedProject?.floors?.find(
      (f) => f.floorNumber === Number(floorId)
    );
    return floor?.apartmens || [];
  }, [selectedProject, floorId]);

  const aparmentSearchImage = useMemo(() => {
    const floor = selectedProject?.floors?.find(
      (f) => f.floorNumber === Number(floorId)
    );
    return floor?.aparmentSearchImage || "";
  }, [selectedProject, floorId]);

  // console.log("floorId => ", floorId);
  // console.log("apartmentsList => ", apartmentsList);

  return (
    <Section bg={"bg-inherit"}>
      <h3 className="text-xl xl:text-5xl font-gilroy uppercase tracking-widest text-primary-bg-blue col-start-2 my-12">
        apartments
      </h3>
      <main className="col-span-10 col-start-2 xl:grid grid-cols-1 xl:grid-cols-12 max-h-fit mb-32 text-primary-bg-blue">
        <>
          {/* ul- proektebis listi */}
          <ul className="hidden border-b-2 border-primary-dark/30 row-span-2 row-start-1 col-span-2 col-start-1 xl:flex items-center justify-normal gap-4 list-none">
            {Projects.map((project) => {
              return (
                <li
                  key={project.id}
                  className={`text-lg tracking-wider  ${
                    selectedProject.id === project.id
                      ? " font-gilroy"
                      : "hidden"
                  } py-4 flex items-center justify-center gap-2`}
                  onClick={() =>
                    delayNavigation(
                      dispatch,
                      navigate,
                      `/projects/${project.name}/apartments`
                    )
                  }
                >
                  <span>{project.label}</span>
                  {selectedProject.id === project.id && (
                    <TiArrowSortedDown className="text-xl" />
                  )}
                </li>
              );
            })}
          </ul>

          <div className="hidden row-start-3 col-span-full xl:col-span-2 xl:col-start-1 pt-8 pr-8 xl:flex flex-col gap-6 justify-start items-start">
            {selectedProject?.floors?.map((floor) => {
              return (
                <div
                  key={floor.floorNumber}
                  className={`w-full h-8 rounded-xl flex items-center justify-center px-2 tracking-wider ${
                    floor.floorNumber === Number(floorId)
                      ? "font-semibold text-primary-bg-blue text-lg  cursor-default "
                      : "opacity-50 cursor-pointer hover:opacity-100 hover:text-lg transition-all transform duration-300"
                  }`}
                  onClick={() =>
                    delayNavigation(
                      dispatch,
                      navigate,
                      `/projects/${selectedProject.name}/block/floor/${floor.floorNumber}`
                    )
                  }
                >
                  {floor.floorNumber} სართული
                </div>
              );
            })}
            {/* <img
              src={selectedProject.listImg}
              alt="K2 Invest Green Home"
              className="w-full h-full object-cover object-center"
            /> */}
            {/* <Link
              className="hidden xl:block w-full max-w-fit relative group text-xl font-bold tracking-wider  py-8"
              to={`/projects/${selectedProject.name}/apartments`}
            >
              ფილტრით ძიება
              <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
            </Link> */}
          </div>
        </>
        <div className="hidden border-b-2 border-l-2 border-primary-dark/30 xl:col-span-10 xl:col-start-3 row-span-2 row-start-1 xl:flex items-center justify-start gap-8  text-xl px-8 font-gilroy">
          <Link
            className={`h-full flex items-center justify-center relative group cursor-pointer  ${
              location.pathname.includes("block") ? "font-bold" : ""
            } tracking-wider`}
            to={`${location.pathname.replace("apartments", "block")}`}
            onClick={(event) => {
              delayNavigation(
                dispatch,
                navigate,
                `${location.pathname.replace("apartments", "block")}`,
                event
              );
            }}
          >
            ვიზუალური სელექცია
            <span
              className={`absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 ${
                location.pathname.includes("block")
                  ? "w-full"
                  : "group-hover:w-full"
              } `}
            ></span>
          </Link>
          <Link
            className={`h-full flex items-center justify-center relative group cursor-pointer  ${
              location.pathname.includes("apartments") ? "font-bold" : ""
            } tracking-wider`}
            to={`/projects/${selectedProject.name}/apartments`}
            onClick={(event) => {
              delayNavigation(
                dispatch,
                navigate,
                `/projects/${selectedProject.name}/apartments`,
                event
              );
            }}
          >
            ფილტრით ძიება
            <span
              className={`absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 ${
                location.pathname.includes("apartments")
                  ? "w-full"
                  : "group-hover:w-full"
              } `}
            ></span>
          </Link>
        </div>
        <div className="relative xl:border-2 border-primary-dark/30 col-span-full xl:col-span-10 xl:col-start-3 row-start-3 flex flex-col items-center justify-start max-h-fit  text-xl">
          <img
            src={aparmentSearchImage}
            alt=""
            className="h-auto w-full object-fill transition-all animate-fadeIn"
          />
          <svg
            className="absolute top-0 left-0 w-full h-full pointer-events-none border-4 border-transparent"
            width="100%"
            height="100%"
            viewBox="0 0 1000 1000"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* {apartmentsList &&
              apartmentsList.length > 0 &&
              apartmentsList.map((apartment) => {
                return (
                  <path
                    key={apartment.number}
                    d={
                      getCoordinatesObjById(
                        apartment.positionId,
                        selectedProject.name,
                        floorId
                      ).coordinates
                    }
                    fill={
                      apartment.isSold
                        ? "rgba(237, 60, 17, 0.3)"
                        : hoveredFlat?.number === apartment.number
                        ? "rgba(210, 242, 155, 0.5)"
                        : "transparent"
                    }
                    stroke="red"
                    strokeWidth="0"
                    // strokeWidth={apartment.number === 55 ? "2" : "0"}
                    className={`${
                      apartment.isSold ? "cursor-not-allowed" : "cursor-pointer"
                    } pointer-events-auto transition-all duration-300`}
                    onMouseEnter={() => setHoveredFlat(apartment)}
                    onMouseLeave={() => setHoveredFlat(null)}
                    onClick={() => {
                      if (!apartment.isSold) {
                        delayNavigation(
                          dispatch,
                          navigate,
                          `/projects/${selectedProject.name}/apartments/floor/${floorId}/apartment/${apartment.number}`
                        );
                      }
                    }}
                    
                  />
                  
                );
              })} */}
              {apartmentsList &&
  apartmentsList.length > 0 &&
  apartmentsList.map((apartment) => {
    const coordinatesObj = getCoordinatesObjById(
      apartment.positionId,
      selectedProject.name,
      floorId
    );

    return (
      <ApartmentPath
        key={apartment.number}
        d={coordinatesObj.coordinates}
        apartment={apartment}
        dispatch={dispatch}
        navigate={navigate}
        selectedProject={selectedProject}
        floorId={floorId}
        hoveredFlat={hoveredFlat}
        setHoveredFlat={setHoveredFlat}
      />
    );
  })}
          </svg>
          {hoveredFlat !== null &&
            !hoveredFlat.isSold &&
            selectedProject.name === "greenhome" && (
              <div className="absolute  top-16 left-16 bg-primary-bg-blue/80 text-xl text-primary-light px-2 py-1 rounded-xl z-50 flex items-center justify-start gap-2 transition-all animate-fadeIn05s">
                <span className="font-semibold flex items-center justify-start tracking-wider">
                  სართული {floorId}
                </span>
                / Ap.
                {
                  <span className="font-semibold flex items-center justify-start">
                    {hoveredFlat.number} /{" "}
                    {
                      getApartmentTypeByIds(
                        hoveredFlat.typeId,
                        hoveredFlat.subTypeId,
                        ApartmentsTypes,
                        selectedProject
                      ).apartmentSubTypeObject.size
                    }{" "}
                    <h1 data-v-418ea57b="">
                      m<sup data-v-418ea57b="">2</sup>
                    </h1>
                  </span>
                }
              </div>
            )}
        </div>
      </main>
    </Section>
  );
};

export default VisualSearchFloor;
